(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('MedalBoardDeleteController',MedalBoardDeleteController);

    MedalBoardDeleteController.$inject = ['$uibModalInstance', 'entity', 'MedalBoard'];

    function MedalBoardDeleteController($uibModalInstance, entity, MedalBoard) {
        var vm = this;

        vm.medalBoard = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MedalBoard.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
